import React from 'react';
import styled from 'styled-components';

import { SOCIETY_COLORS } from '../../../components/General/Variables';

const Wrapper = styled.div`
    height: 40px;
    width: fit-content;
    padding: 8px 16px;
    margin-right: 8px;
    border-radius: 20px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
    white-space: nowrap;
`;

const SelectedBubble = styled(Wrapper)`
    background-color: ${props => props.primary || SOCIETY_COLORS.PRIMARY}1A;
    border: 1px solid ${props => props.primary || SOCIETY_COLORS.PRIMARY};
`;

const RegularBubble = styled(Wrapper)`
    color: rgba(0, 0, 0, 0.87);
    background-color: rgba(245, 245, 245, 1);
    border: 1px solid rgba(245, 245, 245, 1);
`;

const SelectionBubble = ({ isSelected, text, onClick, primary }) => {
    const Bubble = isSelected ? SelectedBubble : RegularBubble;

    return (
        <Bubble primary={primary} onClick={onClick}>
            {text}
        </Bubble>
    );
};

export default SelectionBubble;
